import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { ProductCardContainer, ProductTopInfos, ProductBottomInfos } from '../../../styles';

function SkeletonProductCard() {
  return (
    <ProductCardContainer>
      <ProductTopInfos>
        <div style={{ flex: 1 }}>
          <Skeleton variant="text" width="80%" height={24} />
          <Skeleton variant="text" width="60%" height={20} style={{ marginTop: 4 }} />
        </div>
        <Skeleton variant="rect" width={80} height={58} style={{ borderRadius: 8 }} />
      </ProductTopInfos>

      <ProductBottomInfos>
        <div>
          <Skeleton variant="text" width={100} height={20} />
        </div>
        <div className="bottomRightContainer">
          <div>
            <Skeleton variant="text" width={60} height={20} />
            <Skeleton variant="text" width={80} height={20} style={{ marginTop: 4 }} />
          </div>
          <Skeleton variant="circle" width={32} height={32} />
        </div>
      </ProductBottomInfos>
    </ProductCardContainer>
  );
}

export default SkeletonProductCard;
